// Client Portal: the routes and the sidebar rows of `wealth.onboarding.client-portal` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const PortalAccessAction = lazy(() =>
    import('./client-portal.slots').then((m) => ({ default: m.PortalAccessAction })),
);

export default defineWebFeature({
    id: 'wealth.onboarding.client-portal',
    routes: [
        { frontend: 'portal', path: '', lazy: () => import('@/pages/portal/page') },
        { frontend: 'portal', path: 'login', lazy: () => import('@/pages/portal/login/page') },
        {
            frontend: 'portal',
            path: 'dashboard',
            lazy: () => import('@/pages/portal/dashboard/page'),
        },
        {
            frontend: 'portal',
            path: 'portfolio',
            lazy: () => import('@/pages/portal/portfolio/page'),
        },
        {
            frontend: 'portal',
            path: 'holdings/:isin',
            lazy: () => import('@/pages/portal/holding/page'),
        },
        { frontend: 'portal', path: 'cash', lazy: () => import('@/pages/portal/cash/page') },
        {
            frontend: 'portal',
            path: 'exposure',
            lazy: () => import('@/pages/portal/exposure/page'),
        },
        {
            frontend: 'portal',
            path: 'documents',
            lazy: () => import('@/pages/portal/documents/page'),
        },
        {
            frontend: 'portal',
            path: 'messages',
            lazy: () => import('@/pages/portal/messages/page'),
        },
        // Per-client credential link `/portal/<slug>` — reuses the
        // login page (slug fixed from the URL). React Router ranks
        // the static paths above this dynamic segment, so only a
        // credential slug falls through here.
        { frontend: 'portal', path: ':slug', lazy: () => import('@/pages/portal/login/page') },
    ],
    slots: {
        // "Portal access" on the Desk client record: the IM issues the
        // personal portal link and the password of the client.
        'client.detail.header-actions': [
            {
                key: 'portal-access',
                order: 10,
                when: (ctx) => ctx.view === 'desk',
                Component: PortalAccessAction,
            },
        ],
    },
});
